import ProductDropdown from '../product-dropdown'
import UserData from './UserData'
import styles from './NavBar.module.scss'

interface Props {
  isMobile?: boolean
}

const NavBar: React.FC<Props> = ({ isMobile = false }) => {
  return (
    <div className={`${isMobile ? styles.mobile : ''} ${styles.nav}`}>
      <ProductDropdown />
      <UserData />
    </div>
  )
}

export default NavBar
